import { createSlice } from "@reduxjs/toolkit";
import { actionTypes } from "../../../Auth/_redux/authRedux";

const initialListingsState = {
  activeTab: 0,
};

export const reportTabSlice = createSlice({
  name: "reportTabSlice",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });
  },
  reducers: {
    setReportTabIndex: (state, action) => {
      state.activeTab = action.payload;
    },
  },
});

export const { setReportTabIndex } = reportTabSlice.actions;